import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import { changeDateRangeWeekly } from "../searchFlightsSlice";

function DateRangeWeeklyInput() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const dateRangeWeekly = useAppSelector(
    (state) => state.searchFlights.form.dateRangeWeekly
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);

  const onChange = () => {
    dispatch(changeDateRangeWeekly(!dateRangeWeekly));
  };

  return (
    <div className="field">
      <div className="control">
        <label className="checkbox" title={t("WEEKLY_SCHEDULE")} id="weekly-checkbox">
          <input
            type="checkbox"
            checked={dateRangeWeekly}
            disabled={disabled}
            onChange={onChange}
          />
          {t("WEEKLY_SCHEDULE")}
        </label>
      </div>
    </div>
  );
}

export default DateRangeWeeklyInput;
